// extracted by mini-css-extract-plugin
export default {"root":"navlink_root__BvV7Q title","root_current":"navlink_root_current__5VEdb navlink_root__BvV7Q title","disabled":"navlink_disabled__b0J2H navlink_root__BvV7Q title"};